var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.001,
    height: 160.34,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.759 160.34H90.885l.327-6.969a73.89 73.89 0 0 0-1.466-14.662c-1.886-9.297-5.574-18.134-10.855-26.014-2.588-3.861-5.537-7.466-8.809-10.767s-6.842-6.272-10.676-8.888a71.96 71.96 0 0 0-12.255-6.7c-4.361-1.861-8.897-3.283-13.541-4.244A72.14 72.14 0 0 0 0 83.188V.34h159.759v160z",
    fill: "#242c3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.913 61.354L159.759.34v73.171a73.7 73.7 0 0 1-17.346 2.058 73.4 73.4 0 0 1-43.5-14.215z",
    fill: "#0057ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 160.34H90.306l.331-7.062a74.8 74.8 0 0 0-1.951-17c-1.261-5.392-3.125-10.625-5.556-15.6a74.02 74.02 0 0 0-8.715-13.74c-3.38-4.218-7.212-8.052-11.428-11.434l37.167-37.274a72.41 72.41 0 0 0 19.907 10.291c7.377 2.453 15.102 3.7 22.877 3.692 5.747.002 11.474-.677 17.061-2.024v90.151z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 160.338V69.123c26.024-7.19 53.91-.115 73.358 18.612s27.572 46.326 21.371 72.603z",
    fill: "#E20360"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.001 0v76.421a72 72 0 0 1-12.942 1.167c-38.551 0-69.8-30.441-69.8-67.991a66.86 66.86 0 0 1 .69-9.6z",
    fill: "#0057ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp05);
export default __webpack_public_path__ + "static/media/scrumlr-lp-05.51a6ce34855c7de5051a5afae38c9d8a.svg";
export { ForwardRef as ReactComponent };